// Curated Japanese cyberpunk character roster — humans + creatures
// AI-generated exclusive artwork (soft gray & orange futuristic palette)

const CDN = "https://static.prod-images.emergentagent.com/jobs/1c220779-6edd-4bd3-b2c7-23a9d0486762/images";

export const CHARACTERS = [
  // ===== HUMANS — Japanese cyberpunk =====
  {
    id: "neo-vex",
    name: "Akira Ren",
    type: "human",
    role: "Netrunner",
    img: `${CDN}/15602ec3b76420df5ae9583a1200b7d711823bb61eddb14fac72859305322a01.jpeg`,
    accent: "FF6B00",
    tag: "ICE Breaker",
  },
  {
    id: "kira-zero",
    name: "Yumi Kaze",
    type: "human",
    role: "Console Cowgirl",
    img: `${CDN}/a75a520827c02d34bb5c10604d5207a435a6ed7a129095a67118f0d64a199186.jpeg`,
    accent: "E8DCC8",
    tag: "Neon Heart",
  },
  {
    id: "atlas-rx",
    name: "Kenji Kuro",
    type: "human",
    role: "Street Samurai",
    img: `${CDN}/49c5129eafccae8a458896af69d146591ef8c0a7df0fae6e0f972996bc193768.jpeg`,
    accent: "FFA149",
    tag: "Chrome Edge",
  },
  {
    id: "ronin-7",
    name: "Ronin Hikari",
    type: "human",
    role: "Bounty Hunter",
    img: `${CDN}/5e8fdea7dee3f563f62ec533292d8c168c5907441246ebc869f96c1158394a33.jpeg`,
    accent: "FF6B00",
    tag: "Night Chase",
  },
  {
    id: "kane-virex",
    name: "Daichi Volt",
    type: "human",
    role: "Decker",
    img: `${CDN}/789fdf6e9665beb5c6a5988b35703e7e3cff5a97fadbc824cc35b20564e12a9c.jpeg`,
    accent: "FFB65C",
    tag: "Holo Deck",
  },
  {
    id: "snow-blade",
    name: "Shiro Yuki",
    type: "human",
    role: "Assassin",
    img: `${CDN}/002d72ceadedffd2ad4c31d9571a4e965ba7b5dd8ab301dfc293fb46fc5dcca3.jpeg`,
    accent: "E8DCC8",
    tag: "Cold Drift",
  },
  {
    id: "ghost-line",
    name: "Kage Zero",
    type: "human",
    role: "Hacker",
    img: `${CDN}/df5d5d347d6972c3c7ffed7b536d2aeffba8bc674c7a20d488b1a962f0ee933a.jpeg`,
    accent: "FF6B00",
    tag: "Kitsune Mask",
  },
  {
    id: "ember-skar",
    name: "Hana Ember",
    type: "human",
    role: "Smuggler",
    img: `${CDN}/3a90c4c495d008939b5d338a213ee3155badb43c67740b2e2f67b986b4a39045.jpeg`,
    accent: "FFA149",
    tag: "Last Run",
  },
  {
    id: "vega-jett",
    name: "Rei Kansai",
    type: "human",
    role: "Corp Agent",
    img: `${CDN}/84d1901c1ad88b32d70b9bdb7ff3fa2f0a85162073ff6f8b5841fa860246ffbc.jpeg`,
    accent: "C8C2B4",
    tag: "Black Op",
  },
  {
    id: "ruby-flare",
    name: "Sakura Flare",
    type: "human",
    role: "Fixer",
    img: `${CDN}/a75246eb05628d9ebeb873ff5819493cb046e87929d028eb1dc4c036b8244466.jpeg`,
    accent: "FF6B00",
    tag: "Izakaya Deal",
  },
  {
    id: "razor-king",
    name: "Tetsuo King",
    type: "human",
    role: "Solo",
    img: `${CDN}/ba965a86bad95634330b40bffb68ad87af1e60a0055f87c9b69aff021b7ac213.jpeg`,
    accent: "FFB65C",
    tag: "Iron Arm",
  },
  {
    id: "scarlet-9",
    name: "Ayame Scarlet",
    type: "human",
    role: "Mercenary",
    img: `${CDN}/e47c21ff474892fcfe020ae900bc3044248ebc78acdd6dfdf3a5768cc8858fd8.jpeg`,
    accent: "FF3C1E",
    tag: "Crimson",
  },
  {
    id: "halo-neon",
    name: "Miku Halo",
    type: "human",
    role: "Synth-Rocker",
    img: `${CDN}/ed4f43a390f3ecd44892b9a4b1a9026ef138f5ffa2dd28b5768888e26a3afbd5.jpeg`,
    accent: "FFA149",
    tag: "Stage Glow",
  },

  // ===== CREATURES — cyber yokai =====
  {
    id: "xenon-9",
    name: "Oni-X",
    type: "creature",
    role: "Cyber Oni",
    img: `${CDN}/c5b8e41a2349107a04706c324110fdeb982af00b9248c498c09eed956312ae53.jpeg`,
    accent: "FF6B00",
    tag: "Demon Core",
  },
  {
    id: "void-spawn",
    name: "Yokai Prime",
    type: "creature",
    role: "Brute",
    img: `${CDN}/4aa3bc117948b09759eb9ddbea1d1ffee8fb83a3774ee2523c2c2ee335ea665b.jpeg`,
    accent: "FFA149",
    tag: "Spirit Rig",
  },
  {
    id: "kalva-asur",
    name: "Ryujin Asur",
    type: "creature",
    role: "Dragon Deity",
    img: `${CDN}/94c05d3f8b95242a44970789e9a21cf17d43ebf93f1305d1464b364e9b760c3c.jpeg`,
    accent: "FFB65C",
    tag: "Torii Gate",
  },
];

const BY_ID = Object.fromEntries(CHARACTERS.map((c) => [c.id, c]));

export function getCharacter(id) {
  return BY_ID[id] || CHARACTERS[0];
}

export function characterById(id) {
  return BY_ID[id] || null;
}

export const HUMAN_CHARACTERS = CHARACTERS.filter((c) => c.type === "human");
export const CREATURE_CHARACTERS = CHARACTERS.filter((c) => c.type === "creature");
